import angular from 'angular';
import Logger from '../../../shared/logger';

export class EmployerSearchComponent {
    /* @ngInject */
    constructor($scope, $stateParams, PositionService) {
        PositionService.getPosition($stateParams.positionId)
            .then((response) => {
                $scope.positionData = response.result;
                $scope.data = {
                    employerId: $stateParams.employerId,
                    positionId: $stateParams.positionId,
                    currSearchHistoryIndex: 1,
                    currCandidatePage: 1,
                    talentID: null,
                    searchName: null,
                    showView: 'MainSearch',
                    candidatesName: null,
                    positionData: $scope.positionData,
                    getNotes: () => Promise.resolve(),
                };
            })
            .catch(error => Logger.error(error));
    }
}

export const EmployerSearchComponentConfiguration = {
    template: '<search-component-new ng-if="data" search-data="data"></search-component-new>',
    controller: EmployerSearchComponent,
};

angular.module('TALENYA-FE').component('employerSearchNew', EmployerSearchComponentConfiguration);